import { cilMenu, cilPencil } from '@coreui/icons';
export const icons = Object.assign({
  cilMenu,
  cilPencil,
});
